import getConfig from './config';

const datasource = {
  page: null,
  menu: null,
  social: null,
  signIn: null,
  top: null,
  highlight: null,
  modules: null,
  movie: null,
  drops: null,
  outdoor: null,
  comments: null,
  buttons: null,
  lgpd: null,
  customization: null,
};

const prepare = async () => {
  const config = await getConfig();
  return {
    ...datasource,
    ...config,
  };
};

export default prepare;
